<template>
	<div class="user-table">
		<LinkProducts v-model="visibleLinkProduct" :user="activeUser" @link="onLinkProduct($event)" />

		<Table
			:columns="columns"
			:items="normalizedUsers"
			:rowSelection="rowSelection"
			:loading="isLoading"
			:pagination="pagination"
			@change="$emit('change', $event)"
		>
			<template #action="{}">
				<div class="action">
					<!-- <Tooltip placement="right">
						<template #title>Убить пользователя</template>
						<Button size="small" type="danger" class="action__item" @click="onDelete(user)">
							<Icon type="delete" theme="filled" />
						</Button>
					</Tooltip> -->
				</div>
			</template>

			<template #users="{ ...user }">
				<Users :items="user.producterUsers" @unlink="onUnlinkProduct(user, $event)" />
			</template>

			<template #products="{ ...user }">
				<Tooltip v-if="hasActions" placement="right">
					<template #title>Редактировать список привязанных продуктов</template>
					<Button shape="circle" class="action__item" @click="onStartLinkProduct(user)">
						<Icon type="edit" :style="{ fontSize: '18px' }" />
					</Button>
				</Tooltip>

				<div>
					<a-tag v-for="product in user.products" :key="product.id" color="purple">{{ product.name }}</a-tag>
				</div>
			</template>

			<!-- <template #profile="{ profile, fio, email }">
				<div class="profile">
					<a-tag color="purple">{{ email }}</a-tag>
					<div class="profile__name">{{ fio }}</div>
					<div class="profile__company" v-if="profile.company_short">{{ profile.company_short }}</div>
				</div>
			</template> -->

			<template #sessions="{ ...user }">
				<Tooltip v-if="hasActions" placement="right">
					<template #title>Убить сессии</template>
					<Button v-if="user.sessions.length" size="small" type="danger" class="action__item" @click="onDeleteSession(user)">
						<Icon type="export" />
					</Button>
				</Tooltip>

				<Sessions :items="user.sessions" />
			</template>
		</Table>
	</div>
</template>

<script>
import { Button, Icon, Tooltip } from "ant-design-vue"
import LinkProducts from "./LinkProducts"
import { mapGetters, mapActions } from "vuex"

export default {
	name: "UserTable",

	components: {
		Button,
		Icon,
		Tooltip,
		LinkProducts,
		Table: () => import("@/components/uikit/Table"),
		Users: () => import("./Users"),
		Sessions: () => import("./Sessions")
	},

	props: {
		users: { type: Array, required: true },
		hasActions: { type: Boolean, default: true },
		rowSelection: { type: Object },
		isLoading: { type: Boolean, default: false },
		pagination: { type: [Object, Boolean], default: null }
	},

	data() {
		return {
			selectedUser: null,
			visibleLinkProduct: false,
			activeUser: null
		}
	},

	computed: {
		...mapGetters("User", ["userId"]),

		normalizedUsers() {
			const users = this.users

			return users
		},

		columns() {
			// const action = { slot: "action", title: "", width: 100 }
			// const actions = this.hasActions ? [action] : []

			const allProducts = this.normalizedUsers.reduce((res, user) => {
				user.products.forEach(p => {
					res[p.id] = { text: p.name, value: p.name }
				})

				return res
			}, {})

			return [
				// ...actions,
				{ field: "id", title: "OOHDESK ID", width: 130 },
				{ slot: "users", title: "Аккаунты, пришедшие извне" },
				{
					slot: "products",
					title: "Привязанные продукты",
					filters: Object.values(allProducts),
					onFilter: (value, record) => record.products.map(p => p.name).includes(value)
				},
				// { slot: "profile", title: "Профиль" },
				{ slot: "sessions", title: "Сессии", width: 350 }
			]
		}
	},

	methods: {
		...mapActions("User", ["logout"]),

		/**
		 * Обработать начало привязки продукта к пользователю
		 */
		onStartLinkProduct(user) {
			this.activeUser = user
			this.visibleLinkProduct = true
		},

		/**
		 * Обработать привязку продукта к пользователю
		 */
		async onLinkProduct({ user, productStatuses }) {
			// Получить карту ID продуктов пользователя
			const checkedProducts = Object.entries(productStatuses).reduce((map, [productId, status]) => {
				if (status) {
					map.push(productId)
				}

				return map
			}, [])

			try {
				await this.$context.adminProductService.linkProduct(user.id, checkedProducts)

				if(user.is_admin) {
					await this.logout()
					this.$router.replace({ name: "AuthIndex" }).catch()
				}
			} catch (message) {
				this.$alert.error(message)
			}

			this.$emit("link-product")
		},

		/**
		 * Обработать отвязку продукта от пользователя
		 */
		onUnlinkProduct(user, product) {
			this.$dialog.confirm({
				title: "Вы действительно хотите отвязать продукт от пользователя?",
				content: `Пользователь ${user.email} будет отвязан от продукта ${product.name}`,
				okText: "Отвзяать продукт",
				okType: "danger",
				cancelText: "Отмена",
				onOk: async () => {
					try {
						await this.$context.adminProductService.unlinkProduct(user.id, product.id)

						this.$alert.success(`Продукт ${product.name} успешно отвязан от пользователя ${user.email}`)
						this.$emit("unlink-product")
					} catch (message) {
						this.$alert.error(message)
					}
				}
			})
		},

		/**
		 * Обработать удаление сессий пользователя
		 */
		onDeleteSession(user) {
			this.$dialog.confirm({
				title: "Вы действительно хотите закрыть сессии пользователя?",
				content: `Все открытые сессии пользователя ${user.email} будут закрыты`,
				okText: "Закрыть все сессии",
				okType: "danger",
				cancelText: "Отмена",
				onOk: async () => {
					try {
						await this.$context.adminUserService.deleteSessions(user.id)

						this.$alert.success(`Все сессии пользователя ${user.email} успешно закрыты`)

						// if (this.userId == user.id) {
						// 	await this.$context.authService.logout()
						// } else {
						this.$emit("delete-sessions")
						// }
					} catch (message) {
						this.$alert.error(message)
					}
				}
			})
		},

		/**
		 * Обработать удаление пользователя
		 */
		onDelete(user) {
			this.$dialog.confirm({
				title: "Вы действительно хотите удалить пользователя?",
				content: `Пользователь ${user.email} будет удален безвозвратно`,
				okText: "Удалить",
				okType: "danger",
				cancelText: "Отмена",
				onOk: async () => {
					try {
						await this.$context.adminUserService.deleteUser(user.id)

						this.$alert.success(`Пользователь ${user.email} удален успешно`)
						this.$emit("delete-user")
					} catch (message) {
						this.$alert.error(message)
					}
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
/deep/.ant-radio-wrapper-disabled {
	display: none;
}

.action {
	display: flex;
	flex-direction: column;
	align-items: center;

	&__item {
		margin-bottom: 10px;
	}
}
.profile {
	&__name {
		font-weight: bold;
	}
}
</style>
